/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Expiry2Inputs */

const en_settings_reportingapikeys_generate_expiry2 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Expiry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expiry (TTL)`)
};

/**
* | output |
* | --- |
* | "Expiry (TTL)" |
*
* @param {Settings_Reportingapikeys_Generate_Expiry2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_expiry2 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Expiry2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Expiry2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_expiry2(inputs)
});
export { settings_reportingapikeys_generate_expiry2 as "settings_reportingApiKeys_generate_expiry" }